import React from 'react';
import PropTypes from 'prop-types';

const LinkedProduct = props => (
  <div className="linked-product" key={props.id}>
    <a href={props.contextPath + props.productLinkUrl}>
      <span className="linked-product-thumbnail">
        <img className="linked-product-thumbnail-image" src={props.imagePath} alt={props.productDescription} />
      </span>
    </a>
    <div className="linked-product-detail">
      <p className="linked-product-description"><a href={`${props.contextPath}${props.productLinkUrl}`}>{props.productDescription}</a></p>
      <p className="linked-product-price">{props.price}<span className="linked-product-price-label">{props.pricingLabel}</span></p>
      <p className="linked-product-stock-number">{props.labels.rsStockNo}
        <span className="linked-product-stock-number-label">{props.stockNumber}</span>
      </p>
    </div>
  </div>
);

LinkedProduct.propTypes = {
  stockNumber: PropTypes.string,
  productDescription: PropTypes.string,
  imagePath: PropTypes.string,
  productLinkUrl: PropTypes.string,
  id: PropTypes.number,
  price: PropTypes.string,
  pricingLabel: PropTypes.string,
  labels: PropTypes.shape({
    priceEach: PropTypes.string,
    rsStockNo: PropTypes.string,
    viewProductInfo: PropTypes.string,
    compare: PropTypes.string,
  }),
  contextPath: PropTypes.string,
};

LinkedProduct.defaultProps = {
  stockNumber: null,
  productDescription: null,
  imagePath: null,
  productLinkUrl: null,
  id: null,
  price: '',
  pricingLabel: '',
  labels: {},
  contextPath: '',
};

export default LinkedProduct;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/LinkedProduct/LinkedProduct.js